var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('date-time',{ref:"from",attrs:{"placeholder":"Von","dark":_vm.dark},on:{"changed":_vm.fromChanged}}),_c('date-time',{ref:"to",attrs:{"placeholder":"Bis","dark":_vm.dark},on:{"changed":_vm.toChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }